import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import Blamable            from '@/models/traits/Blamable';
import { Timestampable }   from '@widesk-core/decorators/timestampable';

@doc.path('/cache_purges/{?id}')
@doc.timestampable
abstract class AbstractCachePurgeModel extends Blamable(WebsiteServiceModel) {
	declare protected _tsFilters: {
		partial: string;
	};

	declare private _tsSorts: {
		id: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.string declare urls: string;
}

interface AbstractCachePurgeModel extends Timestampable {}

export default AbstractCachePurgeModel;
